export default import.meta.ROLLUP_FILE_URL_3pKa8$RutHXAosALGmSb2Q